'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-errors/ref.js
// module id = ../../../../es-errors/ref.js
// module chunks = 5